import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import './Sidebar.css';
import addProductIcon from '../Assets/Product_Cart.svg';
import newArrivalsIcon from '../Assets/new-arrival.png';
import bannerIcon from '../Assets/banner_icon.png';
import faqIcon from '../Assets/faq_icon.png';
import dashboardIcon from '../Assets/dashboard_icon.png';
import categoryIcon from '../Assets/category.png';
import designPatternIcon from '../Assets/designpatterns.png'
import videosIcon from '../Assets/videos.png'
import varietyOfAccessoriesIcon from '../Assets/variety.png';
import topSellersIcon from '../Assets/topsellers.png';
import homepageIcon from '../Assets/homepage.png';
import ordersIcon from '../Assets/orders.png';
import usersIcon from '../Assets/users.png';
import ideasIcon from '../Assets/ideas.png'
import featureIcon from '../Assets/new-features.png'
import promoIcon from '../Assets/promo.png'
import ratingIcon from '../Assets/rating.png'

const Sidebar = () => {
  const [openDropdown, setOpenDropdown] = useState(null);

  const toggleDropdown = (dropdown) => {
    setOpenDropdown(openDropdown === dropdown ? null : dropdown);
  };

  const ArrowIcon = ({ isOpen }) => (
    <svg
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      width="20"
      height="20"
      className={`arrow-icon ${isOpen ? 'open' : ''}`}
    >
      <path
        d="M6 15L12 9L18 15"
        stroke="#000000"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </svg>
  );

  return (
    <div className="sidebar">
       {/* Products */}
       <Link to="/dashboard" className="dropdown-item">
        <div className="sidebar-item">
          <img src={dashboardIcon} alt="Add Product" />
          <span>Dashboard</span>
        </div>
      </Link>
      {/* Products */}
      <Link to="/listproduct" className="dropdown-item">
        <div className="sidebar-item">
          <img src={addProductIcon} alt="Add Product" />
          <span>Products</span>
        </div>
      </Link>

      {/* Orders */}
      <Link to="/orders" className="dropdown-item">
        <div className="sidebar-item">
          <img src={ordersIcon} alt="Add Product" />
          <span>Orders</span>
        </div>
      </Link>
      {/* Users */}
      <Link to="/customers" className="dropdown-item">
        <div className="sidebar-item">
          <img src={usersIcon} alt="Add Product" />
          <span>Customers</span>
        </div>
      </Link>
      {/* FAQ */}
      <Link to="/frequently-asked-questions" className="dropdown-item">
        <div className="sidebar-item" >
          <img src={faqIcon} alt="Add Product" />
          <span>FAQ</span>
        </div>
      </Link>
      <Link to="/promo-codes" className="dropdown-item">
        <div className="sidebar-item" >
          <img src={promoIcon} alt="Add Product" />
          <span>Promocode</span>
        </div>
      </Link>
      <Link to="/explore-our-ideas" className="dropdown-item">
        <div className="sidebar-item" >
          <img src={ideasIcon} alt="Add Product" />
          <span>Our Ideas</span>
        </div>
      </Link> 
       {/* Users Dropdown */}
       <div className="dropdown-item " onClick={() => toggleDropdown('homepage')} style={{ cursor: 'pointer' }}>
         <div className='sidebar-item'>
           <img className='icon-img' src={homepageIcon} alt="Homepage" /> HomePage
           <ArrowIcon isOpen={openDropdown === 'homepage'} /></div>
           
       </div>
       {openDropdown === 'homepage' && (
         <div className="dropdown-content">
          <Link to="/homepage/landingbanners" style={{ textDecoration: 'none' , fontSize: '15px'}}>
           <div className="dropdown-item" style={{ justifyContent: 'flex-start'}} >
             <img className='icon-img' src={bannerIcon} alt="accessories" />
             <p className='dropdown-text'>Landing Banners</p>
           </div>
         </Link>
         <Link to="/homepage/browsebycategory" style={{ textDecoration: 'none' , fontSize: '15px'}}>
           <div className="dropdown-item" style={{ justifyContent: 'flex-start'}} >
             <img className='icon-img' src={categoryIcon} alt="accessories" />
             <p className='dropdown-text'>Category</p>
           </div>
         </Link>
         <Link to="/homepage/newarrivals" style={{ textDecoration: 'none' , fontSize: '15px'}}>
           <div className="dropdown-item" style={{ justifyContent: 'flex-start'}} >
             <img className='icon-img' src={newArrivalsIcon} alt="accessories" />
             <p className='dropdown-text'>New Arrivals</p>
           </div>
         </Link>
         <Link to="/homepage/varietyofaccessories" style={{ textDecoration: 'none' , fontSize: '15px'}}>
           <div className="dropdown-item" style={{ justifyContent: 'flex-start'}} >
             <img className='icon-img' src={varietyOfAccessoriesIcon} alt="accessories" />
             <p className='dropdown-text'>Variety of Accessories</p>
           </div>
         </Link>
         <Link to="homepage/topsellers-retrocollections" style={{ textDecoration: 'none' ,  fontSize: '15px'}} >
           <div className="dropdown-item" style={{ marginTop: '10px', justifyContent: 'flex-start'}}>
             <img className='icon-img' src={topSellersIcon} alt="bestsellers"/>
             <p className='dropdown-text'>Top Sellers/Retro</p>
           </div>
         </Link>
         <Link to="homepage/shopbydesignpatterns" style={{ textDecoration: 'none',  fontSize: '15px' }} >
           <div className="dropdown-item" style={{ marginTop: '10px', justifyContent: 'flex-start'}}>
             <img className='icon-img' src={designPatternIcon} alt="design-patterns"/>
             <p className='dropdown-text'>Design Patterns</p>
           </div>
         </Link>
         <Link to="homepage/browsebyvideos" style={{ textDecoration: 'none',  fontSize: '15px' }} >
           <div className="dropdown-item" style={{ marginTop: '10px', justifyContent: 'flex-start'}}>
             <img className='icon-img' src={videosIcon} alt="design-patterns"/>
             <p className='dropdown-text'>Videos</p>
           </div>
         </Link>
         <Link to="homepage/featured-in" style={{ textDecoration: 'none',  fontSize: '15px' }} >
           <div className="dropdown-item" style={{ marginTop: '10px', justifyContent: 'flex-start'}}>
             <img className='icon-img' src={featureIcon} alt="design-patterns"/>
             <p className='dropdown-text'>Featured In</p>
           </div>
         </Link>
         <Link to="homepage/reviews" style={{ textDecoration: 'none',  fontSize: '15px' }} >
           <div className="dropdown-item" style={{ marginTop: '10px', justifyContent: 'flex-start'}}>
             <img className='icon-img' src={ratingIcon} alt="design-patterns"/>
             <p className='dropdown-text'>Reviews</p>
           </div>
         </Link>
       </div>
       )}
     </div>
  );
};

export default Sidebar;
